import { render, staticRenderFns } from "./powers.vue?vue&type=template&id=98f03d52&"
import script from "./powers.vue?vue&type=script&lang=js&"
export * from "./powers.vue?vue&type=script&lang=js&"
import style0 from "./powers.vue?vue&type=style&index=0&id=98f03d52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports